/**
 * Welcome Mat
 * @TODO Needs refactor to custom element
 */
(function (
  jQuery,
  SiteSwitcher,
  CustomSelect,
  enableWelcomeMat,
  allowAutoRedirect,
  currentCountryCode,
  cartCountry,
  debugLog,
) {
  var switcher = SiteSwitcher;

  debugLog("WelcomeMat: loading...", {
    enableWelcomeMat: enableWelcomeMat,
    allowAutoRedirect: allowAutoRedirect,
    currentCountryCode: currentCountryCode,
  });

  // Initialise Welcome Modal
  // The existing site uses jQuery so we leverage it here
  jQuery(function ($) {
    var $modal = $("#welcome-modal");
    var $modalSelect = $modal.find(".custom-select");
    var $modalSelectElement = $modal.find("#custom-select-element");
    var $modalInfo = $modal.find(".modal-info");
    var $modalDiscoverBtn = $modal.find(".btn-discover");
    var $modalAcceptBtn = $modal.find(".btn-accept");
    var $modalTriggerBtn = $("#welcome-mat-modal-button");
    var $modalTriggerBtnFooter = $("#welcome-mat-modal-button-footer");
    var $modalTriggerBtnMobile = $("#welcome-mat-modal-button-mobile");
    var $modalTriggerBtnMobileFooter = $("#welcome-mat-modal-button-mobile-footer");

    $modalTriggerBtn.on("click", function () {
      $(document).trigger("showWelcomeMat");
    });
    $modalTriggerBtnFooter.on("click", function () {
      $(document).trigger("showWelcomeMat");
    });
    $modalTriggerBtnMobile.on("click", function () {
      $(document).trigger("showWelcomeMat");
    });
    $modalTriggerBtnMobileFooter.on("click", function () {
      $(document).trigger("showWelcomeMat");
    });

    function isRedirectFromINTL() {
      return (
        window.location.search.indexOf("redirect_from_intl") > -1 ||
        window.location.search.match(
          /utm_content=intl\.patou\.com_autoredirect/,
        ) ||
        document.referrer.match(/^https?:\/\/intl\.patou\.com/)
      );
    }

    // Current country code when set is saved on localStorage.
    // If it hasn't been set, then we can assume that user
    // hasn't configured their country nor interacted with the
    // welcome mat yet.
    function getCurrentCountryCode() {
      // Check localStorage
      return "localStorage" in window
        ? localStorage.getItem("currentCountryCode") || cartCountry
        : cartCountry;
    }

    function getSelectedCountryCode() {
      var $selectedOption = $modalSelectElement.find(
        "option:eq(" +
          ($modalSelectElement[0].selectedIndex > -1
            ? $modalSelectElement[0].selectedIndex
            : 0) +
          ")",
      );
      var countryCode = $selectedOption.data("location").trim();

      debugLog(
        "WelcomeMat.getSelectedCountryCode",
        $selectedOption,
        countryCode,
      );

      return switcher.sanitiseCountryCode(countryCode);
    }

    function updateSelect(countryCode) {
      var country = SiteSwitcher.getCountryByCode(countryCode);
      if (!country) country = window.countries.ROW;

      var $newOption = $modalSelectElement.find(
        'option[data-location="' + countryCode + '"]',
      );
      var selectedIndex = $modalSelectElement.find("option").index($newOption);

      debugLog("WelcomeMat.updateSelect", countryCode, country, selectedIndex);

      $modalSelectElement[0].selectedIndex = selectedIndex;
      $modalSelectElement.trigger("change");
    }

    function updateInfo(countryCode) {
      var $defaultModalInfo = $modal.find(".modal-info:not([data-location])");
      var $matchingModalInfo = $modal.find(
        '.modal-info[data-location="' + countryCode + '"]',
      );

      debugLog("WelcomeMat.updateInfo", countryCode, $matchingModalInfo);

      // Hide visible info
      $modalInfo.prop("hidden", true);

      if ($matchingModalInfo.length) {
        // Matching info found, show it
        $matchingModalInfo.prop("hidden", false);
        $modalDiscoverBtn.prop("hidden", true);
        $modalAcceptBtn.prop("hidden", false);
      } else {
        // No matching info found, show unsupported info
        $defaultModalInfo.prop("hidden", false);
        $modalDiscoverBtn.prop("hidden", false);
        $modalAcceptBtn.prop("hidden", true);
      }
    }

    function matchCustom(params, data) {
      debugLog("WelcomeMat.matchCustom", params, data);

      var searchTerm = params.term ? params.term.trim() : "";

      // If there are no search terms, return all of the data
      if (searchTerm === "") {
        return data;
      }

      // Do not display the item if there is no 'text' property
      if (
        typeof data.text === "undefined" ||
        data.element.dataset.separator !== undefined ||
        data.element.disabled
      ) {
        return null;
      }

      var fieldsToSearch = [
        data.text,
        data.element.dataset.location,
        data.element.dataset.iso3,
        data.element.dataset.currencyCode,
        data.element.dataset.currencyName,
      ];
      for (var i = 0; i < fieldsToSearch.length; i++) {
        var field = fieldsToSearch[i];
        var fieldText = field.toLowerCase();
        if (fieldText.indexOf(searchTerm) > -1) {
          return data;
        }
      }

      // Always display Rest of the World
      if (data.element.dataset.location === "ROW") return data;

      // Return `null` if the term should not be displayed
      return null;
    }

    function openModal(event) {
      var countryCode =
        event && event.data && event.data.countryCode
          ? event.data.countryCode
          : currentCountryCode;

      debugLog("WelcomeMat.openModal", countryCode, event);

      if (!countryCode) {
        return SiteSwitcher.getCountryByIP().then(function (country) {
          debugLog("WelcomeMat: getCountryByIP", country);
          openModal({
            data: {
              countryCode: country ? country.iso2 : "ROW",
            },
          });
        });
      }

      updateSelect(countryCode);
      updateInfo(countryCode);

      // First open before country set or redirected from INTL
      if (isRedirectFromINTL() || !getCurrentCountryCode()) {
        $(".welcome-modal .close-modal").hide();
        $(".welcome-modal .select2-container").hide();
        $("#welcome-mat-country-select-label .custom-select-label").show();
        $("#welcome-mat-country-select-label .custom-select-value").show();
        $("#custom-select-element").select2("close");
        $(".custom-select-label").on("click", function () {
          $(".welcome-modal .select2-container").show();
          $("#welcome-mat-country-select-label .custom-select-label").hide();
          $("#welcome-mat-country-select-label .custom-select-value").hide();
          $("#custom-select-element").select2("open");
        });
      } else {
        // Subsequent opens after country set
        $(".welcome-modal .close-modal").show();
        $(".welcome-modal .modal-intro").hide();
        $("#welcome-mat-country-select-label .custom-select-label").hide();
        $("#welcome-mat-country-select-label .custom-select-value").hide();
        var $modalTitle = $("#welcome-modal-title");
        if ($modalTitle.data("obc-text")) {
          $modalTitle.text($modalTitle.data("obc-text"));
        }
      }

      // Show the modal
      $modal.modal("show");
    }

    function initModal() {
      debugLog("WelcomeMat.initModal");

      // Events listeners
      $modalSelectElement.on("change", function () {
        debugLog("WelcomeMat: select.onchange", this.selectedIndex);

        if (this.selectedIndex > -1) {
          var countryCode = $modalSelectElement
            .find("option:eq(" + this.selectedIndex + ")")
            .data("location");
          updateInfo(countryCode);
        }
      });

      $modalDiscoverBtn.on("click", function () {
        debugLog("WelcomeMat: discover.onclick");
        var countryCode = getSelectedCountryCode();
        switcher.changeCountry(countryCode, { wm: 1 });
        $modal.modal("hide");
      });

      $modalAcceptBtn.on("click", function () {
        debugLog("WelcomeMat: accept.onclick");
        var countryCode = getSelectedCountryCode();
        switcher.changeCountry(countryCode, { wm: 1 });
        $modal.modal("hide");
      });

      // Initialise the Custom Select
      new CustomSelect({
        $elem: $modalSelect[0],
      });

      $(document).on("select2:open", function () {
        document.querySelector(".select2-search__field").focus();
      });
      $(".select2-container").on("click", function (e) {
        e.preventDefault();
      });

      // Initialise select2
      $("#custom-select-element").select2({
        dropdownParent: $(".welcome-modal"),
        matcher: matchCustom,
      });
    }

    initModal();
    $(document).on("showWelcomeMat", openModal);

    /**
     * There are three ways the welcome mat can be automatically shown:
     *   1. After the cookie banner has been dismissed (happens only once)
     *   2. Straightaway if OneTrust disabled and/or no cookie banner exists
     *   3. User comes from intl.patou.com redirect (redirect_from_intl=1)
     *
     * OneTrust can allow us to configure certain regions to not display
     * a cookie banner, so we need to support option 2.
     *
     * We also need to wait if OneTrust has loaded before we hook into
     * any related events (or just show the Welcome Mat).
     *
     * This will only run if the currentCountryCode is empty.
     */
    if (isRedirectFromINTL() || !getCurrentCountryCode()) {
      window.checkDependencyLoaded("OneTrust", function () {
        var ot = window.OneTrust || window.Optanon;
        debugLog("WelcomeMat: OneTrust has loaded!");

        var otData = ot.GetDomainData();
        switch (otData.ConsentModel.Name) {
          case "opt-in":
            if (!ot.IsAlertBoxClosed()) {
              $(document).one("hideCookieBanner", function () {
                debugLog(
                  "WelcomeMat: show welcome mat after OneTrust cookie banner hide",
                );
                $(document).trigger("showWelcomeMat");
              });
            } else {
              debugLog("WelcomeMat: show welcome mat after OneTrust opt-in");
              $(document).trigger("showWelcomeMat");
            }
            break;

          default:
            debugLog("WelcomeMat: show welcome mat after OneTrust opt-in");
            $(document).trigger("showWelcomeMat");
        }
      });
    }

    debugLog("WelcomeMat: loaded!");
  });
})(
  window.jQuery,
  window.SiteSwitcher,
  window.CustomSelect,
  window.enableWelcomeMat,
  window.allowAutoRedirect,
  window.currentCountryCode,
  window.cartCountry,
  window.debugLog,
);
